module.exports = __webpack_public_path__ + "img/basanLogoLG.81c429ac.png";